import { useSelector } from "react-redux";
import "./FacilityClaimsList.scss";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  TablePagination,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import { IoIosRefresh, IoMdAdd } from "react-icons/io";
import { CiImageOn } from "react-icons/ci";
import { TbGenderEpicene } from "react-icons/tb";
import { PiGenderMaleBold, PiGenderFemaleBold } from "react-icons/pi";
import { MdClose, MdEmail, MdOutlineNumbers, MdPhone } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { IoCheckmarkDoneOutline, IoClose } from "react-icons/io5";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import Announcements from "../../../components/announcement/Announcements";
import { useNavigate } from "react-router-dom";
import { getCssValue } from "../../../utils/genericFunctions";
import { showToast } from "../../../toastService";
import useConfigStore from '../../../zustand/useConfigStore';
import { useTranslation } from "react-i18next";


const FacilityClaimsList = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const { currentUser } = useSelector((state) => state.user);
  // to store plans data
  const { entityPlansData, setEntityPlansData } = useConfigStore();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSearchDialogOpened, setIsSearchDialogOpened] = useState(false);
  const [searchTermClient, setSearchTermClient] = useState("");

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [confirmationActiontext, setConfirmationActiontext] = useState("");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [searchTerm, setSearchTerm] = useState("");
  const [claims, setClaims] = useState([]);
  const [selectedClaim, setSelectedClaim] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: ""
  });
  const [selectedClient, setSelectedClient] = useState(null);
  const [clients, setClients] = useState([]);
  const [rowsPerPageClients, setRowsPerPageClients] = useState(5);
  const [currentClientsPage, setCurrentClientsPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentClaimPage, setCurrentClaimPage] = useState(0);

  // claims
  const handleClaimPageChange = (event, newPage) => {
    setCurrentClaimPage(newPage);
  };

  const handleClaimRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentClaimPage(0);
  };


  const filteredClaims = claims?.filter(
    (row) =>
      row?.cm_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row?.cm_remarks?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row?.cm_facility_ref_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row?.cm_member_ent_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row?.cm_search_params?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedClaims = filteredClaims?.slice(
    currentClaimPage * rowsPerPage,
    currentClaimPage * rowsPerPage + rowsPerPage
  );


  // clients
  const handleClientsPageChange = (event, newPage) => {
    setCurrentClientsPage(newPage);
  };

  const handleClientsRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentClientsPage(0);
  };

  const slicedClients = clients.slice(
    currentClientsPage * rowsPerPageClients,
    currentClientsPage * rowsPerPageClients + rowsPerPageClients
  );




  const fetchClaims = async (firstTime) => {
    try {
      if (firstTime) {
        setIsLoading(true);
      } else {
        setIsProcessing(true);
      }
      const res = await newRequest.post("/meds/findAll",
        {
          facilities_ent_codes: [currentUser?.usr_entity_code],
          claim_statuses: ["Awaiting OTP", "Validated", "Awaiting Approval", "Response Received", "Awaiting Payment", "Partially Paid", "Fully Paid", "Rejected", "Closed"],
          result_limit: 20,
        });
      setClaims(res.data);

      const plans = await newRequest.get(`/allEntity/getEntityPlans/${currentUser?.entity_docid_xx}`, { cm_facility_ent_code: currentUser?.usr_entity_code });
      setEntityPlansData(plans.data);

      setIsLoading(false);
      setIsProcessing(false);
    } catch (error) {
      setIsLoading(false);
      setIsProcessing(false);
    }
  };

  const handleSearchClaims = async () => {
    try {
      setIsLoading(true);
      if (searchTerm) {
        const res = await newRequest.post("/meds/search",
          {
            cm_facility_ent_code: currentUser?.usr_entity_code,
            search_input: searchTerm
          });
        setClaims(res.data);
      } else {
        fetchClaims();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchClient = async () => {
    try {
      setIsLoading(true);
      if (searchTermClient) {
        const res = await newRequest.post("/allEntity/search", { search_input: searchTermClient, limit: 20 });
        setClients(res.data);
        setCurrentClientsPage(0);
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    fetchClaims(true);
  }, []);

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "openVisit") {
        try {
          const res = await newRequest.post("/meds/add",
            {
              cm_remarks: "",
              cm_facility_ent_code: currentUser?.usr_entity_code,
              cm_facility_ref_no: "",
              cm_member_ent_code: selectedClient?.ent_code,
              cm_claim_services: [],
              cm_symptoms: [],
              cm_diagnosis: [],
            });
          if (res.data?.msg === "added") {
            navigate(`/cfm/${res.data?.doc._id}`);
          } else {
            showToast("Error adding claim", "error");
          }
        } catch (error) {
          console.log(error);
        }
      }

    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  return (
    <div className="facility-claims-list">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="facility-claims-list-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="facility-claims-center-wrapper">
            <div className="center-navbar">
              <div className="navbar-left">{t('claims').toUpperCase()}</div>
              <div className="navbar-right">
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="left"
                  endIcon={<IoIosRefresh />} onClick={fetchClaims}>
                  {t('refresh')}
                </CustomLoadingButton>
                <CustomLoadingButton
                  endIcon={<IoMdAdd />}
                  iconPosition="end"
                  borderRadiusType="right"
                  currentTheme={currentTheme}
                  onClick={() => setIsSearchDialogOpened(true)}
                >
                  {t('newClaim')}
                </CustomLoadingButton>
              </div>
            </div>
            <div className="center-content">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                          <span>NO</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                          <div className="search-input-wrapper" style={{ width: "100%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                              className="search-input"
                              type="text"
                              placeholder={`${t('search')} ${t('claim')}`}
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSearchClaims();
                              }}
                            />
                            {searchTerm.length > 0 && (
                              <MdClose
                                onClick={async (e) => {
                                  try {
                                    setSearchTerm("");
                                    await fetchClaims();
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                className="search-input-icon"
                              />
                            )}
                            {searchTerm.length === 0 && (
                              <span className="search-input-icon" />
                            )}
                          </div>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                          <span></span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                          <span>{t('status')}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {paginatedClaims?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedClaim?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedClaim(row);
                              navigate(`/cfm/${row._id}`);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentClaimPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                            <span className="sub-title">{row?.cm_no}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                              <div className='current-user-avatar'>
                                <div className="user-wrapper">
                                  {row?.client_details_xx?.ent_photo_url ? <img src={row?.client_details_xx?.ent_photo_url} alt="" className='avatar' />
                                    :
                                    <CiImageOn style={{
                                      display: "flex",
                                      width: "30px",
                                      height: "30px",
                                      color: "#ccc",
                                      borderRadius: "50%",
                                      objectFit: "cover"
                                    }} />
                                  }
                                  <div className="user-org-view">
                                    <span className="sub-title nowrap">{row?.client_details_xx?.ent_name}                                                                        </span>
                                    <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                      <MdOutlineNumbers className="icon" />
                                      <h1 className="sub-title xrsmall">{row?.client_details_xx?.ent_code}</h1>
                                      <MdEmail className="icon" />
                                      <h1 className="sub-title xrsmall">{row?.client_details_xx?.ent_email || "Unspecified"}</h1>
                                      <MdPhone className="icon" />
                                      <h1 className="sub-title xrsmall">{row?.client_details_xx?.ent_phone_no || "Unspecified"}</h1>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                            <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "5px" }}>
                              <span className={`status ${getCssValue(row?.cm_priority_level)}`} style={{ width: "2px" }} />
                              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span className="sub-title">{row?.cm_priority_level}</span>
                                <span className="sub-title xrsmall soft">{row?.time_ago_xx}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "150px" }}>
                            <span className={`sub-title xrsmall status ${getCssValue(row?.cm_status)}`}>{row?.cm_status}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[10]}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleClaimRowsPerPage}
                    component="div"
                    count={claims?.length}
                    rows={claims}
                    page={currentClaimPage}
                    onPageChange={handleClaimPageChange}
                  />
                </TableContainer>
              </div>
            </div>
          </div>
          <div className="facility-claims-right-wrapper">
            <Announcements />
          </div>
        </motion.div>
      )}
      {isSearchDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper" style={{ width: "850px" }}>
            <div className="overlay-navbar">
              <h1 className="main-title">{t('member').toUpperCase()}</h1>
              <CircularButton currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setClients([]);
                    setSearchTermClient("");
                    setIsSearchDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div className="search-input-wrapper" style={{ width: "100%" }}>
                <FiSearch className="search-input-icon" />
                <input
                  className="search-input"
                  type="text"
                  placeholder="Search. Hint: use Member No, Phone No or ID"
                  value={searchTermClient}
                  onChange={(e) => setSearchTermClient(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSearchClient();
                  }}
                />
                {searchTermClient.length > 0 && (
                  <IoClose
                    onClick={async (e) => {
                      try {
                        setSearchTermClient("");
                        setClients([]);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    className="search-input-icon"
                  />
                )}
                {searchTermClient.length === 0 && (
                  <span className="search-input-icon" />
                )}
              </div>
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                          <span>MEMBER</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "300px" }}>
                          <span>CONTACT</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "120px" }}>
                          <span>STATUS</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                          <span>SELECT</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {slicedClients?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedClient?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedClient(row);
                              // navigate(`/cfm/${row._id}`);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentClaimPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                              <div className='current-user-avatar'>
                                <div className="user-wrapper">
                                  {row?.ent_photo_url ? <img src={row?.ent_photo_url} alt="" className='avatar' />
                                    :
                                    <CiImageOn style={{
                                      display: "flex",
                                      width: "30px",
                                      height: "30px",
                                      color: "#ccc",
                                      borderRadius: "50%",
                                      objectFit: "cover"
                                    }} />
                                  }
                                  <div className="user-org-view">
                                    <span className="main-title">
                                      {row?.ent_name}
                                    </span>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                      {!["Male", "Female"].includes(row?.ent_gender) &&
                                        <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                          <TbGenderEpicene className="icon" />
                                          <h1 className="sub-title xrsmall">{row?.ent_gender}</h1>
                                        </span>}
                                      {["Male"].includes(row?.ent_gender) &&
                                        <span style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "10px" }}>
                                          <PiGenderMaleBold className="icon" />
                                          <h1 className="sub-title xrsmall">{row?.ent_gender}</h1>
                                        </span>}
                                      {["Female"].includes(row?.ent_gender) &&
                                        <span style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                          <PiGenderFemaleBold className="icon" />
                                          <h1 className="sub-title xrsmall">{row?.ent_gender}</h1>
                                        </span>}
                                      <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                        <MdOutlineNumbers className="icon" />
                                        <h1 className="sub-title xrsmall">{row?.ent_code}</h1>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "300px" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <span style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                <MdEmail className="icon" /> <h1 className="sub-title">{row?.ent_email || "Unspecified"}</h1>
                              </span>
                              <span style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                                <MdPhone className="icon" /> <h1 className="sub-title">{row?.ent_phone_no || "Unspecified"}</h1>
                              </span>
                            </div>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "120px" }}>
                            <span className={`status ${getCssValue(row?.ent_status)}`}>{row?.ent_status}</span>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "60px" }}>
                            <CircularButton currentTheme={currentTheme}
                              onClick={() => {
                                try {
                                  setSelectedClient(row);
                                  let action_text = `Open visit for ${row?.ent_name}?`;
                                  setObjectToAction({
                                    object_id: row._id,
                                    action_text: action_text,
                                  });
                                  setConfirmDialogAction(
                                    "openVisit"
                                  );
                                  setConfirmationActiontext(action_text);
                                  setIsConfirmDialogOpen(true);
                                } catch (error) {
                                  console.log(error);
                                }
                              }} icon={<IoCheckmarkDoneOutline />} width={"35px"} height={"35px"} />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {clients?.length > 5 &&
                    <TablePagination
                      rowsPerPageOptions={[5]}
                      rowsPerPage={rowsPerPageClients}
                      onRowsPerPageChange={handleClientsRowsPerPage}
                      component="div"
                      count={clients?.length}
                      rows={clients}
                      page={currentClientsPage}
                      onPageChange={handleClientsPageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
      />
    </div>
  )
}

export default FacilityClaimsList